import styled from "styled-components";
import moment from "moment-timezone";
import { RATypography, RAMap } from "@/components/customs";
import { Row, Col } from "antd";
import { SvgMessage, SvgTime } from "@/assets/icons";
import { AirportLegInfo } from "@/components/molecules";
import { RAEmptyLegLabel } from "@/components/atoms";
import { lightTheme } from "@/themes/ThemeConfig";
import { useSelector } from "react-redux";
import { selectFormatDateTimeDeparture } from "@/stores/slices/authSlice";

export function CardDetails({ formValues = {} }) {
	const {
		from_airport,
		to_airport,
		departure,
		departure_window,
		label,
		note,
		is_automatic = false,
		empty_leg,
	} = formValues;
	const formatDTDeparture = useSelector(selectFormatDateTimeDeparture);

	const getTrips = () => {
		let trips = [];
		const { from_airport, to_airport } = formValues;
		trips.push({ from_airport, to_airport });
		return trips;
	};

	const getTitleDepartureTime = () => {
		if (departure_window || empty_leg?.departure_window) {
			return "Departure Window";
		} else {
			return "Departure time";
		}
	};

	const _renderDepartureTime = () => {
		if (!departure?.utc_datetime && label === "INVITED" && empty_leg?.departure?.utc_datetime) {
			return (
				<>
					{empty_leg?.departure_window?.utc_datetime ? (
						<>
							<Row gutter={[20, 12]}>
								<Col md={3} xs={5}>
									<RATypography variant="body4" color="#595959">
										From
									</RATypography>
								</Col>
								<Col>
									<RATypography variant="sub-heading4" color={lightTheme.color_text_500}>
										{empty_leg?.departure?.utc_datetime
											? moment(empty_leg?.departure?.utc_datetime)
													.tz(from_airport?.location?.timezone)
													.format("DD MMM YYYY")
											: "TBD"}
									</RATypography>
								</Col>
							</Row>
							<Row align="middle" gutter={[20, 12]} style={{ marginTop: "4px" }}>
								<Col md={3} xs={5}>
									<RATypography variant="body4" color="#595959">
										To
									</RATypography>
								</Col>
								<Col>
									<RATypography variant="sub-heading4" color={lightTheme.color_text_500}>
										{empty_leg?.departure_window?.utc_datetime
											? moment(empty_leg?.departure_window?.utc_datetime)
													.tz(from_airport?.location?.timezone)
													.format("DD MMM YYYY")
											: "TBD"}
									</RATypography>
								</Col>
							</Row>
						</>
					) : (
						<RATypography variant="sub-heading4" color={lightTheme.color_text_500}>
							{`${moment(empty_leg?.departure?.utc_datetime)
								.tz(from_airport?.location?.timezone)
								.format("DD MMM YYYY")}`}
						</RATypography>
					)}

					<RATypography variant="label4" color={lightTheme.color_primary_500}>
						INQUIRE FOR DEPARTURE TIME
					</RATypography>
				</>
			);
		}

		if (departure_window) {
			return (
				<>
					<Row gutter={[20, 12]}>
						<Col md={4} xs={5}>
							<RATypography variant="body4" color="#595959">
								From
							</RATypography>
						</Col>
						<Col>
							<RATypography variant="sub-heading4" color={lightTheme.color_text_500}>
								{departure?.utc_datetime
									? moment(departure?.utc_datetime)
											.tz(from_airport?.location?.timezone)
											.format(formatDTDeparture)
									: "TBD"}
							</RATypography>
						</Col>
					</Row>
					<Row align="middle" gutter={[20, 12]} style={{ marginTop: "4px" }}>
						<Col md={4} xs={5}>
							<RATypography variant="body4" color="#595959">
								To
							</RATypography>
						</Col>
						<Col>
							<RATypography variant="sub-heading4" color={lightTheme.color_text_500}>
								{departure_window?.utc_datetime
									? moment(departure_window?.utc_datetime)
											.tz(from_airport?.location?.timezone)
											.format(formatDTDeparture)
									: "TBD"}
							</RATypography>
						</Col>
					</Row>
				</>
			);
		}

		return (
			<RATypography variant="sub-heading4" color={lightTheme.color_text_500}>
				{departure?.utc_datetime
					? moment(departure?.utc_datetime).tz(from_airport?.location?.timezone).format(formatDTDeparture)
					: "TBD"}
			</RATypography>
		);
	};

	return (
		<WrapperFlightInfo>
			<WrapperLegInfo className="ra-box-d">
				<AirportLegInfo from_airport={from_airport} to_airport={to_airport} />
				<WrapperLabel>
					<RAEmptyLegLabel label={label} />
				</WrapperLabel>
			</WrapperLegInfo>
			<RAMap trip={getTrips()} />
			<WrapperItem>
				<CardItem
					icon={<SvgTime color="#595959" />}
					label={getTitleDepartureTime()}
					value={_renderDepartureTime()}
				/>
				{label === "INVITED" && !is_automatic ? (
					<CardItem icon={<SvgMessage color="#595959" />} label="Message" value={note} />
				) : null}
			</WrapperItem>
		</WrapperFlightInfo>
	);
}

const CardItem = ({ icon, label = "", value }) => (
	<Row justify="start" align="top" gutter={[4, 10]}>
		<Col xl={8} lg={10} md={10} sm={12} xs={24}>
			<Row gutter={8}>
				<Col
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					{icon}
				</Col>
				<Col>
					<RATypography variant="body3" color="#595959">
						{label}
					</RATypography>
				</Col>
			</Row>
		</Col>
		<Col xl={16} lg={14} md={14} sm={12} xs={24}>
			<RATypography variant="sub-heading4" color="#222222">
				{value}
			</RATypography>
		</Col>
	</Row>
);

const WrapperFlightInfo = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 20px;
`;
const WrapperItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-top: 20px;
`;
const WrapperLegInfo = styled.div`
	width: 100%;
	padding: 24px clamp(4px, 2vw, 20px);
	gap: 16px;
	min-height: 72px;
	border: 1px dashed #e9e8e8;
	border-radius: 10px;
	position: relative;
`;
const WrapperLabel = styled.div`
	position: absolute;
	top: 0px;
	left: 0px;
`;
